import React from 'react';
import { Avatar, Text } from 'src/@vymo/ui/atoms';
import { getRank } from '../queries';
import styles from '../index.module.scss';

export const getColumns = (columns) =>
  columns.map((col) => {
    if (col.field === 'points') {
      return {
        ...col,
        cell: (val) => <Text type="h6">{val}</Text>,
      };
    }
    if (col.field === 'rank') {
      return {
        ...col,
        cell: (val) => getRank(val),
      };
    }

    if (col.field === 'name') {
      return {
        ...col,
        cell: (val = '') =>
          val ? (
            <div className={styles.leaderboardWrapper__rankingList__item__user}>
              <Avatar
                size="small"
                text={val.charAt(0)}
                background="var(--background-default)"
              />
              <Text>{val}</Text>
            </div>
          ) : (
            <Text>-</Text>
          ),
      };
    }
    return col;
  });
